<script setup>
const props = defineProps(["class"]);
</script>

<template>
    <svg
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        :class="class"
    >
        <path
            d="M13.75 6.66672C13.75 7.91672 13.3333 9.58339 11.3333 10.2501C11.9167 8.83339 12 7.41672 11.5833 6.08339C11 4.33339 9.08333 3.00005 7.75 2.25005C7.41667 2.00005 6.83333 2.33339 6.91667 2.83339C6.91667 3.75005 6.66667 5.08339 5.25 6.50005C3.41667 8.33339 2.5 10.2501 2.5 12.0834C2.5 14.5001 4.16667 17.5001 7.5 17.5001C4.16667 14.1667 6.66667 11.2501 6.66667 11.2501C7.33333 16.1667 10.8333 17.5001 12.5 17.5001C13.9167 17.5001 16.6667 16.5001 16.6667 12.1667C16.6667 9.58339 15.5833 7.58339 14.6667 6.41672C14.4167 6.00005 13.8333 6.25005 13.75 6.66672Z"
            fill="currentColor"
        />
    </svg>
</template>
